export default {
      id: "icon-aksam-yemegi-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-aksam-yemegi",
      toString: function () {
        return this.url;
      }
    }